import React, { useEffect } from 'react'
import { useRouter } from 'next/router'

export default function Custom404() {
  const router = useRouter()

  useEffect(() => {
    router.push('/404')
  }, [router?.isReady])

  return (
    <div className="bg-black text-white pt-[139px]">
      <h1 className="text-6xl font-bold tagline-font items-center leading-[55px] text-center">
        404
      </h1>
      <h4 className="leading-[55px] text-center text-xl font-normal">
        we can&apos;t seem to find the page you&apos;re looking for.
      </h4>
      <div className="text-center text-xl font-normal">
        <a className="leading-[55px]">
          <span
            className="underline cursor-pointer pr-1"
            onClick={() => {
              router.push('/')
            }}
          >
            Click here
          </span>
          to return home.
        </a>
      </div>
    </div>
  )
}
